import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "ma-2 text-left font-weight-medium" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_list_item_title = _resolveComponent("v-list-item-title")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_expansion_panel_title = _resolveComponent("v-expansion-panel-title")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_expansion_panel_text = _resolveComponent("v-expansion-panel-text")!
  const _component_v_expansion_panel = _resolveComponent("v-expansion-panel")!
  const _component_v_expansion_panels = _resolveComponent("v-expansion-panels")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_chip = _resolveComponent("v-chip")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card = _resolveComponent("v-card")!

  return (_openBlock(), _createBlock(_component_v_card, {
    class: "pa-4 elevation-2",
    outlined: ""
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_card_title, null, {
        default: _withCtx(() => _cache[0] || (_cache[0] = [
          _createTextVNode("Slide Details")
        ])),
        _: 1,
        __: [0]
      }),
      _createVNode(_component_v_card_text, { class: "text-left" }, {
        default: _withCtx(() => [
          _createVNode(_component_v_list, { dense: "" }, {
            default: _withCtx(() => [
              _createVNode(_component_v_list_item, null, {
                default: _withCtx(() => [
                  _createVNode(_component_v_row, { class: "w-100" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_col, { cols: "3" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_list_item_title, { class: "font-weight-bold" }, {
                            default: _withCtx(() => _cache[1] || (_cache[1] = [
                              _createTextVNode("Frame Number:")
                            ])),
                            _: 1,
                            __: [1]
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_v_col, { cols: "9" }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.frame.number), 1)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_v_list_item, null, {
                default: _withCtx(() => [
                  _createVNode(_component_v_row, { class: "w-100" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_col, { cols: "3" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_list_item_title, { class: "font-weight-bold" }, {
                            default: _withCtx(() => _cache[2] || (_cache[2] = [
                              _createTextVNode("Latex:")
                            ])),
                            _: 1,
                            __: [2]
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_v_col, { cols: "9" }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.frame.content), 1)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_v_list_item, null, {
                default: _withCtx(() => [
                  _createVNode(_component_v_row, { class: "w-100" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_col, { cols: "3" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_list_item_title, { class: "font-weight-bold" }, {
                            default: _withCtx(() => _cache[3] || (_cache[3] = [
                              _createTextVNode("Is External:")
                            ])),
                            _: 1,
                            __: [3]
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_v_col, { cols: "9" }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.frame.isExternal), 1)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              (_ctx.frame.externalFile)
                ? (_openBlock(), _createBlock(_component_v_list_item, { key: 0 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_row, { class: "w-100" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_col, { cols: "3" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_list_item_title, { class: "font-weight-bold" }, {
                                default: _withCtx(() => _cache[4] || (_cache[4] = [
                                  _createTextVNode("External File:")
                                ])),
                                _: 1,
                                __: [4]
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_v_col, { cols: "9" }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.frame.externalFile), 1)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (_ctx.frame.isReplaced)
                ? (_openBlock(), _createBlock(_component_v_list_item, { key: 1 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_row, { class: "w-100" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_col, { cols: "3" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_list_item_title, { class: "font-weight-bold" }, {
                                default: _withCtx(() => _cache[5] || (_cache[5] = [
                                  _createTextVNode("Replaced:")
                                ])),
                                _: 1,
                                __: [5]
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_v_col, { cols: "9" }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.frame.isReplaced), 1)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (_ctx.frame.isGenerated)
                ? (_openBlock(), _createBlock(_component_v_list_item, { key: 2 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_row, { class: "w-100" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_col, { cols: "3" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_list_item_title, { class: "font-weight-bold" }, {
                                default: _withCtx(() => _cache[6] || (_cache[6] = [
                                  _createTextVNode("Generated:")
                                ])),
                                _: 1,
                                __: [6]
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_v_col, { cols: "9" }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.frame.isGenerated), 1)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (_ctx.frame.selectedSlideTemplate)
                ? (_openBlock(), _createBlock(_component_v_expansion_panels, {
                    key: 3,
                    class: "pa-1 w-100",
                    multiple: ""
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_expansion_panel, {
                        class: "elevation-1",
                        outlined: ""
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_expansion_panel_title, { class: "font-weight-bold" }, {
                            default: _withCtx(() => [
                              _createTextVNode(" Selected Slide Template — " + _toDisplayString(_ctx.frame.selectedSlideTemplate.title || 'No title'), 1)
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_v_expansion_panel_text, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_list, { dense: "" }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_list_item, null, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_row, { class: "w-100" }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_v_col, { cols: "4" }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_v_list_item_title, { class: "font-weight-bold" }, {
                                                default: _withCtx(() => _cache[7] || (_cache[7] = [
                                                  _createTextVNode("Title:")
                                                ])),
                                                _: 1,
                                                __: [7]
                                              })
                                            ]),
                                            _: 1
                                          }),
                                          _createVNode(_component_v_col, { cols: "8" }, {
                                            default: _withCtx(() => [
                                              _createTextVNode(_toDisplayString(_ctx.frame.selectedSlideTemplate.title), 1)
                                            ]),
                                            _: 1
                                          })
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_v_list_item, null, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_row, { class: "w-100" }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_v_col, { cols: "4" }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_v_list_item_title, { class: "font-weight-bold" }, {
                                                default: _withCtx(() => _cache[8] || (_cache[8] = [
                                                  _createTextVNode("Packages:")
                                                ])),
                                                _: 1,
                                                __: [8]
                                              })
                                            ]),
                                            _: 1
                                          }),
                                          _createVNode(_component_v_col, { cols: "8" }, {
                                            default: _withCtx(() => [
                                              _createTextVNode(_toDisplayString(Array.from(_ctx.frame.selectedSlideTemplate.dependenciesPkg).join(', ') || 'None'), 1)
                                            ]),
                                            _: 1
                                          })
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_v_list_item, null, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_row, { class: "w-100" }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_v_col, { cols: "4" }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_v_list_item_title, { class: "font-weight-bold" }, {
                                                default: _withCtx(() => _cache[9] || (_cache[9] = [
                                                  _createTextVNode("TikZ:")
                                                ])),
                                                _: 1,
                                                __: [9]
                                              })
                                            ]),
                                            _: 1
                                          }),
                                          _createVNode(_component_v_col, { cols: "8" }, {
                                            default: _withCtx(() => [
                                              _createTextVNode(_toDisplayString(Array.from(_ctx.frame.selectedSlideTemplate.dependenciesTikz).join(', ') || 'None'), 1)
                                            ]),
                                            _: 1
                                          })
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_v_list_item, null, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_row, { class: "w-100" }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_v_col, { cols: "4" }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_v_list_item_title, { class: "font-weight-bold" }, {
                                                default: _withCtx(() => _cache[10] || (_cache[10] = [
                                                  _createTextVNode("Generated Content:")
                                                ])),
                                                _: 1,
                                                __: [10]
                                              })
                                            ]),
                                            _: 1
                                          }),
                                          _createVNode(_component_v_col, { cols: "8" }, {
                                            default: _withCtx(() => [
                                              _createTextVNode(_toDisplayString(_ctx.frame.selectedSlideTemplate.generatedContend), 1)
                                            ]),
                                            _: 1
                                          })
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }),
          (_ctx.frame.template)
            ? (_openBlock(), _createBlock(_component_v_divider, {
                key: 0,
                class: "my-2"
              }))
            : _createCommentVNode("", true),
          _createElementVNode("p", _hoisted_1, " Die vorgeschlagene Folien: " + _toDisplayString(_ctx.frame.template ? 'vorhanden' : 'noch nicht generiert'), 1),
          (_ctx.frame.template)
            ? (_openBlock(), _createBlock(_component_v_expansion_panels, {
                key: 1,
                multiple: ""
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.frame.template.slideTemplate, (slide, index) => {
                    return (_openBlock(), _createBlock(_component_v_expansion_panel, { key: index }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_expansion_panel_title, null, {
                          default: _withCtx(() => [
                            _createTextVNode(" Template of Slide " + _toDisplayString(index) + " — " + _toDisplayString(slide.title || 'No title') + " ", 1),
                            _createVNode(_component_v_chip, {
                              color: _ctx.getScoreColor(slide.score),
                              class: "ml-3 pl-2",
                              label: "",
                              small: ""
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(" Score: " + _toDisplayString(slide.score === 1 ? '1.0' : slide.score), 1)
                              ]),
                              _: 2
                            }, 1032, ["color"])
                          ]),
                          _: 2
                        }, 1024),
                        _createVNode(_component_v_expansion_panel_text, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_list, { dense: "" }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_list_item, null, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_row, { class: "w-100" }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_col, { cols: "4" }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_v_list_item_title, { class: "font-weight-bold" }, {
                                              default: _withCtx(() => _cache[11] || (_cache[11] = [
                                                _createTextVNode("Packages:")
                                              ])),
                                              _: 1,
                                              __: [11]
                                            })
                                          ]),
                                          _: 1
                                        }),
                                        _createVNode(_component_v_col, { cols: "8" }, {
                                          default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(Array.from(slide.dependenciesPkg).join(', ') || 'None'), 1)
                                          ]),
                                          _: 2
                                        }, 1024)
                                      ]),
                                      _: 2
                                    }, 1024)
                                  ]),
                                  _: 2
                                }, 1024),
                                _createVNode(_component_v_list_item, null, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_row, { class: "w-100" }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_col, { cols: "4" }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_v_list_item_title, { class: "font-weight-bold" }, {
                                              default: _withCtx(() => _cache[12] || (_cache[12] = [
                                                _createTextVNode("TikZ:")
                                              ])),
                                              _: 1,
                                              __: [12]
                                            })
                                          ]),
                                          _: 1
                                        }),
                                        _createVNode(_component_v_col, { cols: "8" }, {
                                          default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(Array.from(slide.dependenciesTikz).join(', ') || 'None'), 1)
                                          ]),
                                          _: 2
                                        }, 1024)
                                      ]),
                                      _: 2
                                    }, 1024)
                                  ]),
                                  _: 2
                                }, 1024),
                                (slide.generatedContend)
                                  ? (_openBlock(), _createBlock(_component_v_list_item, { key: 0 }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_row, { class: "w-100" }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_v_col, { cols: "4" }, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_v_list_item_title, { class: "font-weight-bold" }, {
                                                  default: _withCtx(() => _cache[13] || (_cache[13] = [
                                                    _createTextVNode("Generated Content:")
                                                  ])),
                                                  _: 1,
                                                  __: [13]
                                                })
                                              ]),
                                              _: 1
                                            }),
                                            _createVNode(_component_v_col, { cols: "8" }, {
                                              default: _withCtx(() => [
                                                _createTextVNode(_toDisplayString(slide.generatedContend), 1)
                                              ]),
                                              _: 2
                                            }, 1024)
                                          ]),
                                          _: 2
                                        }, 1024)
                                      ]),
                                      _: 2
                                    }, 1024))
                                  : _createCommentVNode("", true)
                              ]),
                              _: 2
                            }, 1024)
                          ]),
                          _: 2
                        }, 1024)
                      ]),
                      _: 2
                    }, 1024))
                  }), 128))
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}